import { render, staticRenderFns } from "./AssetItemPreview.vue?vue&type=template&id=cf84dd66&scoped=true&"
import script from "./AssetItemPreview.vue?vue&type=script&lang=js&"
export * from "./AssetItemPreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf84dd66",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VImg})
